const RecoveryPaymentButtonStyleType = {
  DEFAULT: 'DEFAULT',
  PENDING: 'PEDNING',
  RETRY: 'RETRY',
};

export default RecoveryPaymentButtonStyleType;
